import { Button } from "@material-ui/core"
import Image from "next/image"
import { useRouter } from "next/router"
import styled from "styled-components"
import { useQuickPurchaseContext } from "./QuickPurchaseContext"

const StyledModalContainer = styled.div<{ $visible: boolean }>`
  width: 100%;
  height: 100vh;
  display: ${(p) => (p?.$visible ? "flex" : "none")};
  justify-content: center;
  align-items: flex-end;
  z-index: 10;
  position: fixed;
  background: rgba(0, 0, 0, 0.3);

  ${(p) => p.theme.breakpoints.up("md")} {
    align-items: center;
  }
`

const StyledModal = styled.div`
  width: 100%;
  height: 400px;
  padding: 16px 16px 36px 16px;
  display: flex;
  flex-direction: column;

  background: #fff;
  box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.12);

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 490px;
    height: 356px;
    gap: 24px;
  }
`

const StyledQuitBtn = styled.button`
  border-radius: 50%;
  width: 31px;
  height: 31px;
  padding: 9px;
  background: #f7f7f7;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.16);
    background: #f7f7f7;
  }

  .MuiButton-label {
    width: 10px;
    height: 10px;
  }
`

const StyledX = styled(Image)``

const StyledUpper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StyledLower = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 0;
  }
`

const textDefaults = `
font-style: normal;
line-height: normal;
color: var(--Black, var(--Primary-Black, #000));
padding: 0;
margin: 0;
text-align: center;
`

const StyledTitle = styled.h3`
  ${textDefaults}
  text-align: center;
  font-family: NarkisBlock;
  font-size: 32px;
  letter-spacing: 0.48px;
  height: 29px;
  margin-top: 8px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 16px;
  }
`

const StyledByline = styled.p`
  ${textDefaults}
  font-family: NarkisBlock;
  font-size: 18px;
  letter-spacing: 0.27px;
  margin-top: 8px;
  max-width: 328px;

  ${(p) => p.theme.breakpoints.up("md")} {
    max-width: 400px;
  }
`

const StyledLogo = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 5.76px;
  background: var(--Green, #264f36);
  display: flex;
  justify-content: center;
  align-items: center;
`

const buttonTextDefaults = `
  color: var(--Black, var(--Primary-Black, #000));
  text-align: center;
  font-family: NarkisBlock;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.36px;
`

const StyledFilledBtn = styled(Button)<{ onClick?: any }>`
  ${buttonTextDefaults}
  font-weight: bold;
  display: flex;
  height: 48px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 8px;
  background: var(--Yellow, #ffbc0d);

  &:hover {
    background: var(--Yellow, #ffbc0d);
    box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);
  }
`

const StyledOutlineButton = styled(Button)`
  ${buttonTextDefaults}
  font-weight: bold;
  display: flex;
  height: 48px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 2px solid var(--Yellow, #ffbc0d);
  background: var(--White, #fff);

  &:hover {
    border: 2.25px solid var(--Yellow, #ffbc0d);
    background: var(--White, #fff);
    box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);
  }
`

const StyledLogoImg = styled(Image)``

type ExitPopupProps = {
  showExitModal: boolean
  prevPath?: string
}

const ExitPopup = ({ showExitModal }: ExitPopupProps) => {
  const { setShowExitModal } = useQuickPurchaseContext()
  const router = useRouter()

  return (
    <StyledModalContainer $visible={showExitModal}>
      <StyledModal>
        <StyledQuitBtn onClick={() => setShowExitModal(false)}>
          <StyledX src="/x-icon.svg" width={9} height={9} />
        </StyledQuitBtn>
        <StyledUpper>
          <StyledLogo>
            <StyledLogoImg src="/big-m.svg" width={51} height={47} />
          </StyledLogo>
          <StyledTitle>בטוח שרוצה לצאת?</StyledTitle>
          <StyledByline>
            ביציאה מתהליך קניית גיפטקארד, הפרטים לא יישמרו ונצטרך להתחיל את
            תהליך הקנייה מחדש
          </StyledByline>
        </StyledUpper>
        <StyledLower>
          <StyledFilledBtn onClick={() => setShowExitModal(false)}>
            רוצה להמשיך
          </StyledFilledBtn>
          <StyledOutlineButton
            onClick={() => {
              router.push("/")
              setTimeout(() => {
                setShowExitModal(false)
              }, 500)
            }}
          >
            רוצה לצאת
          </StyledOutlineButton>
        </StyledLower>
      </StyledModal>
    </StyledModalContainer>
  )
}

export default ExitPopup
